import {NotificationsInterfaces} from '@namespaces/notifications.namespace';
import {Params} from '@angular/router';
import {UrlManagerService} from '@services/url-manager.service';
import {DateService} from '@services/date.service';

export class NotificationMessage {
    id: number;
    body: string;
    isRead: boolean;
    title: string;
    links: NotyLink[];
    date: string;
    time: string;
    extraData: string[];

    constructor(message: NotificationsInterfaces.Message) {
        this.id = message.id;
        this.body = message.body;
        this.title = message.title;
        this.isRead = message.is_read;
        this.extraData = message.extra && message.extra.data ? message.extra.data : [];

        const date = DateService.timestampToDate(message.created_at);
        this.date = DateService.dateToFormat(date);
        this.time = DateService.getTime(date);

        this.prepareLinks(message.extra && message.extra.links ? message.extra.links : []);
    }

    private prepareLinks(sourceLinks: NotificationsInterfaces.ExtraLink[]) {
        this.links = [];
        sourceLinks.forEach(l => {
            this.links.push({
                label: l.label,
                path: UrlManagerService.getUrlWithoutQuery(l.url),
                queryParams: UrlManagerService.getQueryParams(l.url),
            });
        });
    }
}

interface NotyLink {
    label: string;
    path: string;
    queryParams?: Params;
}
